var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutopayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8543 33.5147C46.4759 25.9472 31.3408 24.3255 31.8813 33.5147C32.2311 39.4607 34.9848 38.333 38.3677 39.4607C41.611 40.5418 44.8543 40.5418 44.8543 46.4877C44.8543 50.2715 34.042 54.5958 32.4219 46.4877",
    stroke: "#009300",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9062 52.9741V56.2174",
    stroke: "#009300",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9062 22.7039V25.9471",
    stroke: "#009300",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2156 19.9999C46.1953 8.70628 28.2315 8.19506 16.9723 19.9999C10.2702 27.0269 9.1655 43.9067 14.0304 53.096",
    stroke: "#008600",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0726 43.4377L18.9599 59.3291L4.75391 52.1519L18.0726 43.4377Z",
    fill: "#008600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7695 63.5844C36.0173 72.1165 52.8626 69.1044 61.3947 56.8566C69.9268 44.6089 65.9629 35.6189 63.8009 31.835",
    stroke: "#008600",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6117 30.7854L59.4742 39.7702L58.2617 23.9004L72.6117 30.7854Z",
    fill: "#008600"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.3811,
    cy: 62.7027,
    rx: 10.8108,
    ry: 10.8108,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3811 51.8918C52.4352 51.8918 47.5703 56.7567 47.5703 62.7027C47.5703 68.6486 52.4352 73.5135 58.3811 73.5135C64.3271 73.5135 69.1919 68.6486 69.1919 62.7027C69.1919 56.7567 64.3271 51.8918 58.3811 51.8918ZM58.3811 71.3513C53.6136 71.3513 49.7325 67.4702 49.7325 62.7027C49.7325 57.9351 53.6136 54.054 58.3811 54.054C63.1487 54.054 67.0298 57.9351 67.0298 62.7027C67.0298 67.4702 63.1487 71.3513 58.3811 71.3513ZM63.3433 57.9243L56.219 65.0486L53.419 62.2594L51.8946 63.7837L56.219 68.1081L64.8676 59.4594L63.3433 57.9243Z",
    fill: "#008600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopayIcon);
export default __webpack_public_path__ + "static/media/AutopayIcon.48e7c419857e4f02f91802e0c88c6101.svg";
export { ForwardRef as ReactComponent };